import { DAIMI_SV_INTRO, DAIMI_SV_SLUG } from '@/content/daimiServices'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-fourth report with a designed page of its own, and the ninth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Technology cut earlier the same day (*"referans alarak ilgili
  // sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture
  // of the live page, the cover as two overlapping 2000px crops, Figure 1 and the
  // report mockup. See `content/daimiServices.ts` and `pages/DaimiServices.tsx`.
  // Not to be confused with the Public Services cut listed above it, which is a
  // separate report and still on the shared template.
  ...focus(
    DAIMI_SV_SLUG,
    'Services',
    'daimi-report-2026-services-cover',
    '11fc59ab-6a32-4e7c-9788-e174802c41bd-digitopia-daimi-2026-report-services.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held
  // on the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_SV_INTRO.body,
  layout: 'services-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiServicesChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 16
